import BillingLeadGenTable from '../BillingLeadGenTable';
import React from 'react';
import s from './s.module.less';
import { Button, Popover, Tabs } from 'antd';
import ProListingBg from './imgs/frame2.jpg';
import Frame from './imgs/frame.png';
import useProviderHomeInfo from 'hooks/useProviderHomeInfo';
import { PATH } from 'constants/path';
import { useNavigate } from 'react-router-dom';

const JoinProListings = () => {
    const [activeTab, setActiveTab] = React.useState<'Invoices' | 'Free credits'>('Invoices');
    const [providerHasJoinedProListings, setProviderHasJoinedProListings] = React.useState(false);
    const [data] = useProviderHomeInfo();
    const uniprofileApproveCompleted = !!data?.uniprofileApproveCompleted;
    const navigate = useNavigate();
    return (
        <div className={s.wrap}>
            <div className={s.title}>
                <span>Pro-Listings investment</span>
            </div>
            <div className={s.top}>
                <img src={Frame} alt="frame" />
            </div>
            <div className={s.card}>
                <div className={s.cardContent}>
                    <div className={s.leftSection}>
                        <div className={s.newBadge}>New</div>
                        <div className={s.textSection}>
                            <h2 className={s.title}>
                                Increase your visibility with Klarity Health&apos;s{' '}
                                <span className={s.highlight}>Pro-Listings</span>
                            </h2>
                            <p className={s.description}>
                                Secure top placement in search results. Pay only when a patient books, not clicks.
                                Pro-listings are available to providers who is listed on Klarity.
                            </p>
                            <Button
                                type="primary"
                                className={s.startButton}
                                disabled={!uniprofileApproveCompleted}
                                onClick={() => navigate(`${PATH.DASHBOARD}/${PATH.MARKETING}?tab=prolisting`)}
                            >
                                Get started
                            </Button>
                        </div>
                    </div>
                    <div className={s.rightSection}>
                        <img src={ProListingBg} alt="pro-listings" />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default JoinProListings;
